import React from 'react';
import { Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  subtitle: string;
}

export const QueuedOfflineOrdersSubtitle: React.FC<Props> = ({ subtitle }) => {
  const theme = useTheme();

  return (
    <Text
      style={[{ ...TYPOGRAPHY.listSubtitle, color: theme.colors.inactiveText }]}
      testID="queued-offline-orders-subtitle"
    >
      {subtitle}
    </Text>
  );
};
